import { ArrowRight } from "lucide-react";
import { FEATURED } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import Img from "@/components/site/Img";

export const Work = () => (
  <section
    id="work"
    data-testid="work-section"
    className="relative bg-ivory py-20 md:py-28"
  >
    <div className="mx-auto max-w-shell px-6 md:px-10">
      <Reveal>
        <div className="flex items-end justify-between gap-6">
          <div className="label-xs text-slate">Featured projects</div>
        </div>
        <div className="mt-5 hair-light" />
      </Reveal>

      <div className="mt-10 grid gap-8 md:grid-cols-3">
        {FEATURED.map((p, i) => (
          <Reveal key={p.src + p.client} delay={i * 0.07}>
            <figure data-testid={`featured-${i}`} className="group">
              <div className="frame aspect-[4/3]">
                <Img
                  src={p.src}
                  alt={p.alt}
                  className="w-full h-full object-cover"
                />
              </div>

              <figcaption className="mt-5">
                <div className="label-xs text-obsidian">{p.client}</div>
                <div className="mt-2 label-xs text-slate">{p.location}</div>
                <div className="mt-4 flex items-center justify-between gap-4">
                  <h3 className="text-[0.95rem] text-obsidian/85">{p.title}</h3>
                  <ArrowRight
                    size={15}
                    className="text-slate group-hover:text-obsidian group-hover:translate-x-1 transition-all duration-400 shrink-0"
                  />
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Work;
